import React, { createContext, useState, useContext } from 'react';

const PasswordContext = createContext();

export const PasswordProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const login = (password) => {
    return new Promise((resolve, reject) => {
      if (password === '@mcore!') {
        setIsAuthenticated(true); 
        resolve();
      } else {
        reject(new Error('Incorrect password')); 
      }
    });
  };

  return (
    <PasswordContext.Provider value={{ isAuthenticated, login }}>
      {children}
    </PasswordContext.Provider>
  );
};

export const usePassword = () => useContext(PasswordContext);
